import React, { createContext, useCallback, useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api, { formatApiError } from "@/lib/api";
import { toast } from "sonner";

const CustomerCtx = createContext(null);

export function useCustomer() {
  const ctx = useContext(CustomerCtx);
  if (!ctx) throw new Error("useCustomer must be used inside <CustomerProvider>");
  return ctx;
}

export function CustomerProvider({ children }) {
  const nav = useNavigate();
  const [state, setState] = useState({
    loading: true,
    active: false,
    datasets: [],
    subscription: null,
    days_left: null,
    renewal_alert: false,
  });
  const [filterOpts, setFilterOpts] = useState({ states: [], cities_by_state: {} });

  const load = useCallback(async () => {
    try {
      const { data } = await api.get("/customer/datasets");
      setState({ loading: false, ...data });
      if (!data.active) {
        const my = await api.get("/subscription/my").then((r) => r.data);
        if (!my) nav("/onboarding");
        else if (my.status === "pending") nav("/pending");
        return;
      }
      const sub = data.subscription;
      const panIndia =
        sub?.gst_coverage?.type === "pan_india" ||
        sub?.mca_coverage?.type === "pan_india";
      if (panIndia || sub?.data_type === "both") {
        try {
          const opts = await api.get("/customer/filter-options").then((r) => r.data);
          if (opts.active) setFilterOpts(opts);
        } catch {
          // filter options optional
        }
      }
    } catch (e) {
      toast.error(formatApiError(e?.response?.data?.detail) || e.message);
      setState((s) => ({ ...s, loading: false }));
    }
  }, [nav]);

  useEffect(() => {
    load();
    const t = setInterval(load, 60000);
    return () => clearInterval(t);
  }, [load]);

  const isPanIndia =
    state.subscription?.gst_coverage?.type === "pan_india" ||
    state.subscription?.mca_coverage?.type === "pan_india";

  return (
    <CustomerCtx.Provider value={{ ...state, filterOpts, isPanIndia, reload: load }}>
      {children}
    </CustomerCtx.Provider>
  );
}
